// extracted by mini-css-extract-plugin
module.exports = {"banner":"DetailsView_banner__PAjDm","tagLine":"DetailsView_tagLine__Er9oj","details":"DetailsView_details__oQekD"};